import { useMemo } from "react";
import { faChildReaching, faNoteSticky, faTrash } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { Tooltip } from "reactstrap";
import { useVisible } from "../../../../../utils/hooks/useVisible";
import { isAddedTimeSheet, isNonProductiveTimeSheet } from "../helpers";
import { useUser } from "../../../../../utils/hooks/user";
import moment from "moment-timezone";

const MissPunchTooltip = ({ original, openMissPunchModal, isMyTimesheet }) => {
    const { t } = useTranslation();
    const { visible, toggle } = useVisible();
    const id = `miss-punch-${original.user.id}-row-${original.id}`;
   
    return (
        <>
            <span id={id}>
                <FontAwesomeIcon
                    icon={faChildReaching}
                    size="lg"
                    className={classNames(
                        (original?.missPunchStatus !== "pending") && "text-primary",
                        "cursor-pointer",
                        original.missPunchStatus === "approved" && "text-info"
                    )}
                    onClick={(original?.missPunchStatus !== "pending" && isMyTimesheet) ? () => openMissPunchModal(original) : undefined}
                />
            </span>
            {["pending", "approved"].includes(original?.missPunchStatus) && (
                <Tooltip target={id} isOpen={visible} toggle={toggle}>
                    <span className="text-sm font-weight-bolder px-2 m-2">
                        {original?.missPunchStatus === "pending"
                            ? t("miss-punch-request-info")
                            : t("miss-punch-request-approved")}
                    </span>
                </Tooltip>
            )}
        </>
    );
}

export const useActionsColumn = ({ edit, remove, openMissPunchModal, isMyTimesheet }) => {
    const { t } = useTranslation();
    const user = useUser();

    return useMemo(() => ({
        Header: t("actions"),
        id: "actions",
        hideable: false,
        Cell: ({ row, cell, data }) => {
            const { original } = row;
            const disabled = cell.disabled;
            const isAdded = isAddedTimeSheet(original);
            if (isAdded && !original.isTouched) {
                return null;
            }
            const timesheets = data?.filter((item) => moment(item.date).format("YYYY-MM-DD") === moment(original.date).format("YYYY-MM-DD") && !item?.isAdded);
            const nonProductiveTimeSheets = timesheets.filter((timesheet) => isNonProductiveTimeSheet(timesheet));

            return (
                <div className="d-flex justify-content-end align-items-center gap-x-3">
                    {(edit && !disabled && !original.isNonProductiveTime) && (
                        <span
                            className={classNames(
                                "cursor-pointer", 
                                original?.note ? "text-primary" : "text-muted",
                                original?.locked && "text-muted"
                            )}
                            onClick={() => edit(original)}
                        >
                            <FontAwesomeIcon icon={faNoteSticky} size="lg" />
                        </span>
                    )}

                    {(!original?.locked && (
                        (!isAdded && remove && !original.isNonProductiveTime) ||
                        (original.isNonProductiveTime && !!user?.roles?.find((role) => role?.id === "ROLE_ADMIN") && nonProductiveTimeSheets.length === timesheets.length)
                    )) && (
                            <span
                                className="cursor-pointer text-red"
                                onClick={() => remove({ data: original.id })}
                            >
                                <FontAwesomeIcon icon={faTrash} size="lg" />
                            </span>
                        )}
                </div>
            );
        },
    }), [t, edit, remove, user?.roles, openMissPunchModal, isMyTimesheet]);
};
